import { render, staticRenderFns } from "./LogMarketReceive.vue?vue&type=template&id=ccfacbf6&"
import script from "./LogMarketReceive.vue?vue&type=script&lang=js&"
export * from "./LogMarketReceive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports